<template>
  <div class="business-item container-fluid">
    <div class="row" style="padding: 15px 62px 32px 62px">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="business-item-wrapper">
          <div class="business-item-content">
            <div class="content" @click="handleClick">
              <div class="img-wrapper">
                <img src="../../assets/home/1.png" alt="系统建设" />
                <p class="content-title">系统建设</p>
              </div>
              <p class="content-text">提供固定资产全生满周期解决方案帮忙您精细化管理资产，分入账与非入账模式方便与财务对账的同时，亦符合实物管理的特性。</p>
            </div>
          </div>
          <div class="business-item-content">
            <div class="content" @click="handleClick">
              <div class="img-wrapper">
                <img src="../../assets/home/2.png" alt="决算服务" />
                <p class="content-title">决算服务</p>
              </div>
              <p class="content-text">
                适合行政事业单位的财务系统，兼容最新政府财务制度和以前的行政财务制度同时并存，可以上传电子附件并支持查阅打印等，同时可以作为财务电子凭证库管理系统使用。
              </p>
            </div>
          </div>
          <div class="business-item-content">
            <div class="content" @click="handleClick">
              <div class="img-wrapper">
                <img src="../../assets/home/3.png" alt="顾问服务" />
                <p class="content-title">顾问服务</p>
              </div>
              <p class="content-text">为您单位提供全面的财务问题，单位内控问题等专业的咨询服务：我们提供完善的决算服务。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    handleClick() {
      this.$router.push({
        path: "/productPresentation",
      });
    },
  },
};
</script>
<style scoped>
.business-item {
  padding-top: 32px;
}
.business-item-wrapper {
  display: flex;
}
.business-item-content {
  flex: 1 1 auto;
  width: 33.33%;
}
.business-item-content:hover > .content > .content-text {
  color: #346bdc;
}
.business-item-content:hover > .content > .img-wrapper {
  color: #346bdc;
}
.business-item-content:nth-child(2) {
  margin: 0 40px;
}
.business-item-content > .content > .img-wrapper {
  font-size: 24px;
  font-weight: bold;
  color: #000000;
  position: relative;
}
.business-item-content > .content > .img-wrapper > img {
  width: 100%;
  height: auto;
}
.content-title {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.content-text {
  font-size: 14px;
  color: #525252;
  line-height: 30px;
}
@media (max-width: 768px) {
  .business-item-wrapper{
    flex-direction: column;
    align-items: center;
  }
  .business-item-wrapper .business-item-content {
    width: 100%;
    flex: 0 0 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/business.vue